import { Link } from 'react-router-dom';
import { featuredArticles, articles } from '@/mocks/articles';

export default function ArticleSection() {
  const allArticles = articles;

  return (
    <section className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精选文章
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            深度影评、观影指南、影视资讯，与你分享关于电影的一切
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-md cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-500">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-14">
          <h3 className="text-lg font-heading text-foreground-900 mb-6">
            最新文章
          </h3>
          <div className="space-y-4">
            {allArticles.slice(4).map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-full sm:w-40 h-24 rounded-lg overflow-hidden flex-shrink-0">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {article.tags[0]}
                    </span>
                    <span className="text-xs text-foreground-500">
                      {article.author} · {article.publishDate}
                    </span>
                  </div>
                  <h4 className="text-sm font-medium text-foreground-900 leading-snug mb-1 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h4>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/dianying-tuijian"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}